import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { action: "#" }
const _hoisted_3 = { class: "controls" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "Master volume", -1 /* HOISTED */)
const _hoisted_5 = { class: "controls" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, "Balance", -1 /* HOISTED */)
const _hoisted_7 = ["onUpdate:modelValue", "onInput"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'card-panel': true, 'hidden': !$setup.hidden })
  }, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("form", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _withDirectives(_createElementVNode("input", {
              type: "range",
              step: "0.1",
              min: "0",
              max: "10",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.volumeLevel) = $event)),
              onInput: _cache[1] || (_cache[1] = ($event: any) => ($setup.updateVolume($setup.volumeLevel)))
            }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
              [_vModelText, $setup.volumeLevel]
            ]),
            _createElementVNode("output", null, _toDisplayString($setup.volumeLevel) + "     ", 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _withDirectives(_createElementVNode("input", {
              type: "range",
              step: "0.1",
              min: "-1",
              max: "1",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.balance) = $event)),
              onChange: _cache[3] || (_cache[3] = ($event: any) => ($setup.updateBalance($setup.balance)))
            }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
              [_vModelText, $setup.balance]
            ]),
            _createElementVNode("output", null, _toDisplayString($setup.balance) + "     ", 1 /* TEXT */)
          ]),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList([60, 170, 350, 1000, 3500, 10000], (item, index) => {
            return _createElementVNode("div", {
              key: index,
              class: "controls"
            }, [
              _createElementVNode("label", null, _toDisplayString(item) + "Hz", 1 /* TEXT */),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                step: "1",
                min: "-30",
                max: "30",
                "onUpdate:modelValue": ($event: any) => (($setup.gains[index]) = $event),
                onInput: ($event: any) => ($setup.updateGains(index))
              }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_7), [
                [_vModelText, $setup.gains[index]]
              ]),
              _createElementVNode("output", null, _toDisplayString($setup.gains[index]) + " dB ", 1 /* TEXT */)
            ])
          }), 64 /* STABLE_FRAGMENT */))
        ])
      ])
    ])
  ], 2 /* CLASS */))
}